'use strict';
export const API_URL = 'http://api.chanceball.com/api/v1/';
export const GAME_TYPE = {
            ladder: {START: '출발', LINE: '줄수', ODDEVEN: '홀짝', ALLKILL: '출줄'},
            dari: {START: '출발', LINE: '줄수', ODDEVEN: '홀짝', ALLKILL: '출줄'},
            powerLadder: {START: '출발', LINE: '줄수', ODDEVEN: '홀짝', ALLKILL: '출줄'},
            powerball: {PODDEVEN: '파홀짝', PLOWHIGH: '파언오', NODDEVEN: '일홀짝', NLOWHIGH: '일언오', NSCALE: '대중소'}
        };
export const VER = '1.2.2';
export const WEB_URL = '//www.chanceball.com/';
export const GCM_SENDER_ID = '518236463500';
export const BBS_NAME = {free: '자유 게시판', humor: '유머 게시판', share: '분석공유 게시판', notice: '공지사항'};
export const GAME_NAME = {
    // ladder: '사다리',
    // dari: '다리다리',
    powerball: '파워볼',
    powerLadder: '파워사다리'
};
/*
export class AppSettings {

chanceballApp.config(function($cordovaInAppBrowserProvider) {
    let defaultOptions = {
        location: 'no',
        clearcache: 'no',
        toolbar: 'no'
    };

    document.addEventListener("deviceready", function () {
        $cordovaInAppBrowserProvider.setDefaultOptions(defaultOptions);
    }, false);
});

chanceballApp.config(function($mdDateLocaleProvider) { //

    // for calendar
    $mdDateLocaleProvider.months = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
    $mdDateLocaleProvider.shortMonths = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
    $mdDateLocaleProvider.shortDays = ['일', '월', '화', '수', '목', '금', '토'];
    $mdDateLocaleProvider.formatDate = function(date) {
        return moment(date).format('YYYY-MM-DD');
    };
});

chanceballApp.config(function($ionicConfigProvider) { //
    // 백버튼의 텍스트를 삭제한다.
    $ionicConfigProvider.backButton.text(''); // .icon('ion-ios7-arrow-left');
    $ionicConfigProvider.backButton.previousTitleText(false);
    $ionicConfigProvider.views.maxCache(0);
    $ionicConfigProvider.scrolling.jsScrolling(false); // this mean overflow-scroll='true'.
});



} */
